import * as Types from '../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InventoryMoveRequestsListQueryVariables = Types.Exact<{
  input: Types.InventoryMoveRequestsInput;
  options?: Types.InputMaybe<Types.InventoryMoveRequestsOptions>;
}>;


export type InventoryMoveRequestsListQuery = { readonly __typename?: 'Query', readonly inventoryMoveRequests: { readonly __typename?: 'InventoryMoveRequestPaged', readonly totalCount: number, readonly items: ReadonlyArray<{ readonly __typename?: 'InventoryMoveRequest', readonly id: string, readonly createdAt: string, readonly status: Types.InventoryMoveRequestStatus, readonly actionedAt?: string | null, readonly actionerNotes?: string | null, readonly receivingLocation: { readonly __typename?: 'Location', readonly name: string }, readonly requestor: { readonly __typename?: 'User', readonly person?: { readonly __typename?: 'UserPerson', readonly firstname?: string | null, readonly lastname?: string | null } | null } }> } };


export const InventoryMoveRequestsListDocument = gql`
    query inventoryMoveRequestsList($input: InventoryMoveRequestsInput!, $options: InventoryMoveRequestsOptions) {
  inventoryMoveRequests(input: $input, options: $options) {
    totalCount
    items {
      id
      createdAt
      status
      receivingLocation {
        name
      }
      requestor {
        person {
          firstname
          lastname
        }
      }
      actionedAt
      actionerNotes
    }
  }
}
    `;

/**
 * __useInventoryMoveRequestsListQuery__
 *
 * To run a query within a React component, call `useInventoryMoveRequestsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryMoveRequestsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryMoveRequestsListQuery({
 *   variables: {
 *      input: // value for 'input'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useInventoryMoveRequestsListQuery(baseOptions: Apollo.QueryHookOptions<InventoryMoveRequestsListQuery, InventoryMoveRequestsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InventoryMoveRequestsListQuery, InventoryMoveRequestsListQueryVariables>(InventoryMoveRequestsListDocument, options);
      }
export function useInventoryMoveRequestsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InventoryMoveRequestsListQuery, InventoryMoveRequestsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InventoryMoveRequestsListQuery, InventoryMoveRequestsListQueryVariables>(InventoryMoveRequestsListDocument, options);
        }
export type InventoryMoveRequestsListQueryHookResult = ReturnType<typeof useInventoryMoveRequestsListQuery>;
export type InventoryMoveRequestsListLazyQueryHookResult = ReturnType<typeof useInventoryMoveRequestsListLazyQuery>;
export type InventoryMoveRequestsListQueryResult = Apollo.QueryResult<InventoryMoveRequestsListQuery, InventoryMoveRequestsListQueryVariables>;